import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useDebounce } from '../../../features/redListedCompanies/helpers/debounceSearch';
import { useApi } from '../useApi';
import { keys } from './company.key';

export enum CompaniesSortControls {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  RegistrationNumberAsc = 'registrationNumber_ASC',
  RegistrationNumberDesc = 'registrationNumber_DESC',
  ExpirationDateAsc = 'expirationDate_ASC',
  ExpirationDateDesc = 'expirationDate_DESC',
}

export function useGetAllCompanies(
  clientId: string,
  take: number,
  skip: number,
  search?: string,
  sort?: CompaniesSortControls
) {
  const getApi = useApi();
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const debounce = useDebounce();

  useEffect(() => {
    if (typeof search === 'string') {
      debounce(() => setDebouncedSearch(search), 300);
    }
  }, [search]);

  const getCompanies = async () => {
    const api = await getApi();
    const res = await api.companiesFindAllForClient(
      clientId,
      debouncedSearch,
      take,
      skip,
      sort
    );
    return res;
  };

  const query = useQuery({
    queryKey: keys.findAll(take, skip, debouncedSearch, sort),
    queryFn: getCompanies,
    keepPreviousData: true,
  });

  return {
    ...query,
    data: query.data?.data,
    count: query.data?.headers['x-total-count'],
  };
}
